import React from 'react';
import { useEffect, useState } from 'react';
import * as S from './styles';
import CheckboxFilter from '../../CheckboxFilter';
import { Slider } from '@material-ui/core';
import CurrencyFormat from 'react-currency-format';
import { Skeleton } from '@material-ui/lab';
import { useGlobal } from '../../../contexts/globalContext';
import { addFeeByDestinoFerias } from '../../../utils/addFeeByDestinoFerias';

const buildOptions = (results, keyFn, labelFn) => {
	const counts = {};
	const labels = {};
	results.forEach((r) => {
		const key = keyFn(r);
		if (!key) return;
		counts[key] = (counts[key] || 0) + 1;
		labels[key] = labelFn(r) || key;
	});
	return Object.entries(counts).map(([key, count]) => ({ name: key, label: labels[key], value: count, disabled: false }));
};

const CarFilter = ({
	changeFilter,
	searchState,
	results,
	loading,
	error,
	buscaAtual,
}) => {
	const [state, setState] = useState({
		carType: [],
		rentalCias: [],
		pickupShops: [],
		dropoffShops: [],
		fares: [],
		transmissions: [],
		fuels: [],
	});
	const [value, setValue] = useState([0, 1000]);
	const [amount, setAmount] = useState([0, 500]);

	const [rentalCias, setRentalCias] = useState([]);
	const [carTypes, setCarTypes] = useState([]);
	const [pickupShops, setPickupShops] = useState([]);
	const [dropoffShops, setDropoffShops] = useState([]);
	const [fares, setFares] = useState([]);
	const [transmissions, setTransmissions] = useState([]);
	const [fuels, setFuels] = useState([]);

	const { user, signed } = useGlobal();
	const [shortenCoinAlias, setShortenCoinAlias] = useState('Pts');

	const getValuesByUser = (val) => {
		let value = signed ? val * user.catalog.catalogCurrencyConfig.conversionRate : val;
		if (user.campaign) value = addFeeByDestinoFerias(value, buscaAtual);
		return signed ? Math.ceil(Math.round(value)) : value;
	};

	useEffect(() => {
		changeFilter(state);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state]);

	useEffect(() => {
		const values = results.map((r) => r.totalAmount).filter(Boolean);
		const max = values.length > 0 ? Math.max(...values) : 1000;

		setAmount([0, max]);
		setValue([0, max]);
		setRentalCias(buildOptions(results, (r) => r.companyCode, (r) => r.companyName));
		setCarTypes(buildOptions(results, (r) => r.category, (r) => r.categoryName));
		setPickupShops(buildOptions(results, (r) => r.pickupShopName, (r) => r.pickupShopName && r.pickupAddress ? `${r.pickupShopName} - ${r.pickupAddress}` : r.pickupShopName));
		setDropoffShops(buildOptions(results, (r) => r.dropoffShopName, (r) => r.dropoffShopName && r.dropoffAddress ? `${r.dropoffShopName} - ${r.dropoffAddress}` : r.dropoffShopName));
		setFares(buildOptions(results, (r) => r.fareKey, (r) => r.fareName));
		setTransmissions(buildOptions(results, (r) => r.transmissionName, (r) => r.transmissionName));
		setFuels(buildOptions(results, (r) => r.fuelName, (r) => r.fuelName));
	}, [results]);

	useEffect(() => {
		setState((s) => ({ ...s, amount: { valorInicial: amount[0], valorFinal: amount[1] } }));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [amount]);

	useEffect(() => {
		setShortenCoinAlias(user?.campaign?.campaignConfig?.shortenCoinAlias || 'Pts');
	}, [user?.campaign?.campaignConfig?.shortenCoinAlias]);

	const toggleItem = (key, item) => {
		setState((s) => {
			const list = s[key];
			const next = list.includes(item.name)
				? list.filter((x) => x !== item.name)
				: [...list, item.name];
			return { ...s, [key]: next };
		});
	};

	const renderGroup = (title, options, stateKey) => {
		if (!options || options.length === 0) return null;
		return (
			<div className='filter-group'>
				<S.FilterTitle>{title}</S.FilterTitle>
				{options.map((cbx, index) => (
					<CheckboxFilter
						key={index}
						label={cbx.label}
						name={cbx.name}
						disabled={cbx.disabled}
						valueLabel={cbx.value}
						onChange={(obj) => toggleItem(stateKey, obj)}
					/>
				))}
			</div>
		);
	};

	return loading ? (
		<Skeleton variant='rect' width={'100%'} height={1000} />
	) : (
		<div>
			{!error && (
				<S.Wrapper>
					{renderGroup('Locadoras', rentalCias, 'rentalCias')}
					{renderGroup('Loja de Retirada', pickupShops, 'pickupShops')}
					{renderGroup('Loja de Devolução', dropoffShops, 'dropoffShops')}
					{renderGroup('Tarifas', fares, 'fares')}
					{renderGroup('Tipos de Carros', carTypes, 'carType')}
					{renderGroup('Transmissão', transmissions, 'transmissions')}
					{renderGroup('Combustível', fuels, 'fuels')}

					<div className='filter-group'>
						<S.FilterTitle>Valor</S.FilterTitle>
						<S.ThinText>
							{signed && !user?.guest && !user?.campaign?.disablePointActivity ? (
								<span>
									{getValuesByUser(amount[0])} {shortenCoinAlias} -{' '}
									{getValuesByUser(amount[1])} {shortenCoinAlias}
								</span>
							) : (
								<>
									<CurrencyFormat value={amount[0]} displayType={'text'} decimalSeparator=',' decimalScale={2} prefix={'R$ '} />
									{' - '}
									<CurrencyFormat value={amount[1]} displayType={'text'} decimalSeparator=',' decimalScale={2} prefix={'R$ '} />
								</>
							)}
						</S.ThinText>
						<Slider
							value={amount}
							onChange={(event, newValue) => setAmount(newValue)}
							valueLabelDisplay='off'
							aria-labelledby='range-slider'
							min={0}
							max={value[1]}
						/>
					</div>
				</S.Wrapper>
			)}
		</div>
	);
};

export default CarFilter;
